import React, { useEffect, useState } from 'react';
import { computeRoundArea, computeRoundVolume } from '../helpers/math';
import { getStoredValue, saveToStorage, storeValue } from '../helpers/storage';
import Crust from './Crust';
import { MoldType } from '../helpers/consts-and-types';
import PropTypes from 'prop-types';
import styles from './MoldContainer.module.scss';
import useDebouncedEffect from '../hooks/use-debounced-effect';
import useLocalize from '../hooks/use-localize';
import useMeasureChangeHandler from '../hooks/use-measure-change-handler';

const MoldRound = ({ crustVolume, setArea, setCrustArea, setCrustUrl, setCrustVolume, setMoldUrl, setVolume, side }) => {
  const { localize } = useLocalize();
  const [radius, setRadius] = useState(() => getStoredValue(side, 'round', 'radius', 8));
  const [height, setHeight] = useState(() => getStoredValue(side, 'round', 'height', 4.5));

  useEffect(() => {
    saveToStorage(`${side}-type`, 'round');
  }, []);

  useDebouncedEffect(() => setMoldUrl(`${radius}-${height}`), [height, radius]);

  useEffect(() => {
    storeValue(side, 'round', [
      ['radius', radius],
      ['height', height],
    ]);
  }, [radius, height]);

  useEffect(() => {
    setArea(computeRoundArea(radius));
  }, [radius, setArea]);

  useEffect(() => {
    setVolume(computeRoundVolume(radius, height));
  }, [height, radius, setVolume]);

  const handleOnRadiusChange = useMeasureChangeHandler(setRadius, (value) => value / 2);
  const handleOnHeightChange = useMeasureChangeHandler(setHeight);

  return (
    <div className={styles.grid}>
      <div>{localize('mold.diameter')}</div>
      <div className={styles.measure}>{radius * 2}&nbsp;cm</div>
      <input max='50' min='1' onChange={handleOnRadiusChange} step='.5' type='range' value={radius * 2} />
      <div>{localize('mold.height')}</div>
      <div className={styles.measure}>{height}&nbsp;cm</div>
      <input max='10' min='1' onChange={handleOnHeightChange} step='.5' type='range' value={height} />
      <Crust height={height} moldType={MoldType.Round} radius={radius} setArea={setCrustArea} setCrustUrl={setCrustUrl} setVolume={setCrustVolume} side={side} volume={crustVolume} />
    </div>
  );
};

MoldRound.propTypes = {
  crustVolume: PropTypes.number.isRequired,
  setArea: PropTypes.func.isRequired,
  setCrustArea: PropTypes.func.isRequired,
  setCrustUrl: PropTypes.func.isRequired,
  setCrustVolume: PropTypes.func.isRequired,
  setMoldUrl: PropTypes.func.isRequired,
  setVolume: PropTypes.func.isRequired,
  side: PropTypes.string.isRequired,
};

export default MoldRound;
